// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChangeIndicator_change-indicator__MSQWq {
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: #DFFFEA;
  color: #17C653;
  padding: 0.075rem 0.43rem;
  border-radius: 4px;
}
.ChangeIndicator_change-indicator__negative__w-XH0 {
  background-color: #FFEEF3;
  color: #F8285A;
}
.ChangeIndicator_change-indicator__negative__w-XH0 .ChangeIndicator_change-indicator__icon__compact__2U8GA {
  background-color: #FFEEF3;
  color: var(--m-danger);
}
.ChangeIndicator_change-indicator__negative__w-XH0 .ChangeIndicator_change-indicator__value__N6P4- {
  color: #F8285A;
}
.ChangeIndicator_change-indicator__compact__dNrZ2 {
  background-color: transparent;
  color: #10b669;
  padding-right: 0;
}
.ChangeIndicator_change-indicator__compact__dNrZ2 .ChangeIndicator_change-indicator__value__N6P4- {
  font-weight: 700;
}
.ChangeIndicator_change-indicator__icon__compact__2U8GA {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #d1fadf;
  color: #10b669;
  color: var(--m-success);
}
.ChangeIndicator_change-indicator__icon__compact__2U8GA svg {
  font-size: 10px !important;
}
.ChangeIndicator_change-indicator__icon__\\+4PWC svg {
  font-size: 0.6rem;
}
.ChangeIndicator_change-indicator__value__N6P4- {
  font-size: 0.75rem;
  font-weight: 500;
}

[m-data-theme=dark] .ChangeIndicator_change-indicator__MSQWq {
  background-color: #353a51;
  color: #10b669;
}
[m-data-theme=dark] .ChangeIndicator_change-indicator__negative__w-XH0 {
  background-color: #353a51;
}
[m-data-theme=dark] .ChangeIndicator_change-indicator__negative__w-XH0 * {
  color: #E42855 !important;
}
[m-data-theme=dark] .ChangeIndicator_change-indicator__negative__w-XH0 .ChangeIndicator_change-indicator__icon__compact__2U8GA {
  background-color: #5b494e;
}
[m-data-theme=dark] .ChangeIndicator_change-indicator__compact__dNrZ2 {
  color: #10b669;
  background-color: transparent;
}
[m-data-theme=dark] .ChangeIndicator_change-indicator__icon__compact__2U8GA {
  background-color: #353a51;
  color: var(--m-success);
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/ChangeIndicator/ChangeIndicator.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AACJ;AACI;EACI,yBAAA;EACA,cAAA;AACR;AACQ;EACI,yBAAA;EACA,sBAAA;AACZ;AAEQ;EACI,cAAA;AAAZ;AAII;EACI,6BAAA;EACA,cAAA;EACA,gBAAA;AAFR;AAIQ;EACI,gBAAA;AAFZ;AAOQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;EACA,uBAAA;AALZ;AAOY;EACI,0BAAA;AALhB;AASQ;EACI,iBAAA;AAPZ;AAWI;EACI,kBAAA;EACA,gBAAA;AATR;;AAcI;EACI,yBAAA;EACA,cAAA;AAXR;AAaQ;EACI,yBAAA;AAXZ;AAaY;EACI,yBAAA;AAXhB;AAcY;EACI,yBAAA;AAZhB;AAgBQ;EACI,cAAA;EACA,6BAAA;AAdZ;AAkBY;EACI,yBAAA;EACA,uBAAA;AAhBhB","sourcesContent":[".change-indicator {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    background-color: #DFFFEA;\n    color: #17C653;\n    padding: 0.075rem 0.43rem;\n    border-radius: 4px;\n\n    &__negative {\n        background-color: #FFEEF3;\n        color: #F8285A;\n\n        .change-indicator__icon__compact {\n            background-color: #FFEEF3;\n            color: var(--m-danger);\n        }\n\n        .change-indicator__value {\n            color: #F8285A;\n        }\n    }\n\n    &__compact {\n        background-color: transparent;\n        color: #10b669;\n        padding-right: 0;\n\n        .change-indicator__value {\n            font-weight: 700;\n        }\n    }\n\n    &__icon {\n        &__compact {\n            width: 18px;\n            height: 18px;\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            background-color: #d1fadf;\n            color: #10b669;\n            color: var(--m-success);\n\n            svg {\n                font-size: 10px !important;\n            }\n        }\n        \n        svg {\n            font-size: .6rem;\n        }\n    }\n\n    &__value {\n        font-size: 0.75rem;\n        font-weight: 500;\n    }\n}\n\n[m-data-theme='dark'] {\n    .change-indicator {\n        background-color: #353a51;\n        color: #10b669;\n\n        &__negative {\n            background-color: #353a51;\n\n            * {\n                color: #E42855 !important;\n            }\n    \n            .change-indicator__icon__compact {\n                background-color: #5b494e;\n            }\n        }\n    \n        &__compact {\n            color: #10b669;\n            background-color: transparent;\n        }\n    \n        &__icon {\n            &__compact {\n                background-color: #353a51;\n                color: var(--m-success);\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"change-indicator": `ChangeIndicator_change-indicator__MSQWq`,
	"change-indicator__negative": `ChangeIndicator_change-indicator__negative__w-XH0`,
	"change-indicator__icon__compact": `ChangeIndicator_change-indicator__icon__compact__2U8GA`,
	"change-indicator__value": `ChangeIndicator_change-indicator__value__N6P4-`,
	"change-indicator__compact": `ChangeIndicator_change-indicator__compact__dNrZ2`,
	"change-indicator__icon": `ChangeIndicator_change-indicator__icon__+4PWC`
};
export default ___CSS_LOADER_EXPORT___;
